export default "__VITE_ASSET__Df7OGF2G__"